var React = require('react');

function LeaderToolsActive (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.625 2.22192H3.375C2.13236 2.22192 1.125 3.21685 1.125 4.44415V16.6664C1.125 17.8937 2.13236 18.8886 3.375 18.8886H14.625C15.8676 18.8886 16.875 17.8937 16.875 16.6664V4.44415C16.875 3.21685 15.8676 2.22192 14.625 2.22192Z","stroke":"#222224","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.25 1.11096H6.75V3.33318H11.25V1.11096Z","stroke":"#222224","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M5.91748 11.4L7.82998 13.2889L12.015 9.14441","stroke":"#8C10FE","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

LeaderToolsActive.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"};

module.exports = LeaderToolsActive;

LeaderToolsActive.default = LeaderToolsActive;
